import type { DetectionModel } from '@/types/models/DetectionModel'

export type DetectionState = {
    detection?: any
    detections: DetectionModel[]
}

export enum EDetectionActions {
    FETCH_DETECTIONS = 'fetchDetections',
    GET_LATEST_DETECTIONS = 'getLatestDetections',
    EXPORT_DETECTIONS = 'exportDetections',

    FETCH_PRESENCES = 'fetchPresences',
    EXPORT_PRESENCES = 'exportPresences',

    FETCH_TRIPS = 'fetchTrips',
    EXPORT_TRIPS = 'exportTrips',

    FETCH_PERSONS_TRIPS = 'fetchPersonsTrips',
    EXPORT_PERSONS_TRIPS = 'exportPersonsTrips',

    FETCH_SHUTTLES_TRIPS = 'fetchShuttlesTrips',
    EXPORT_SHUTTLES_TRIPS = 'exportShuttlesTripls'
}

export enum EDetectionMutations {
    SET_DETECTIONS = 'setDetections',
    SET_TOTAL = 'setTotal',
    SET_LOADING = 'setLoader'
}
